import React from 'react'

import { cn } from '~/styled'

import { Table } from '../table/Table'
import { Tile } from '../tile/Tile'
import { SkeletonLoader } from './Skeleton'

export const SkeletonTable = ({
  numberOfColumns = 4,
  numberOfRows = 4,
  columnWidth,
  className
}: {
  numberOfColumns?: number
  numberOfRows?: number
  columnWidth?: Record<number, string>
  className?: string
}) => {
  return (
    <Tile className={cn('p-6', 'flex-row', 'gap-4', 'relative', className)}>
      <Table size="md">
        <Table.Header theme="white">
          {Array.from({ length: numberOfColumns }, (_, index) => index).map(
            (columnIndex) => (
              <Table.HeaderCell key={columnIndex}>
                <SkeletonLoader
                  style={{ '--width': columnWidth?.[columnIndex] || '100px' }}
                  className="h-4 w-(--width) rounded-xl"
                />
              </Table.HeaderCell>
            )
          )}
        </Table.Header>
        <Table.Body striped={false}>
          {Array.from({ length: numberOfRows }, (_, index) => index).map(
            (rowIndex) => (
              <Table.Row key={rowIndex}>
                {Array.from(
                  { length: numberOfColumns },
                  (_, index) => index
                ).map((columnIndex) => (
                  <Table.Cell key={columnIndex} className="border-none">
                    <SkeletonLoader
                      style={{
                        '--width': columnWidth?.[columnIndex] || '100px'
                      }}
                      className="bg-grey-200 h-4 w-(--width) rounded-xl"
                    />
                  </Table.Cell>
                ))}
              </Table.Row>
            )
          )}
        </Table.Body>
      </Table>
    </Tile>
  )
}
